import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getPageMeta } from '../config/pageMeta';

export default function PageMeta() {
  const { pathname } = useLocation();
  const meta = getPageMeta(pathname);

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={meta.url} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:image" content={meta.image} />
      <meta property="og:site_name" content={meta.siteName} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={meta.url} />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={meta.image} />

      <link rel="canonical" href={meta.url} />
    </Helmet>
  );
}
